import React from 'react'
import { Button, Modal } from 'syngenta-react-components'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import clear from '../../../assets/icons/clear.svg'

const ProductionPlanModal = ({ submissionStatus, showModal, handleClose }) => {
  let content = <TableStatus status="LOADING" />
  let bottomRow = (
    <Button disabled customClassName="mr10">
      Continue
    </Button>
  )
  let cancelFunction = handleClose

  switch (submissionStatus) {
    case 'SUCCESS':
      content = <p>Production plan successfully completed!</p>
      bottomRow = (
        <Button
          styleType="success"
          customClassName="mr10"
          onClick={() => handleClose('SUCCESS')}
        >
          Continue
        </Button>
      )
      cancelFunction = () => handleClose('SUCCESS')
      break
    case 'FAILED':
      content = <p>Production plan creation failed.</p>
      bottomRow = (
        <Button customClassName="mr10" onClick={() => handleClose('FAILED')}>
          Cancel
        </Button>
      )
      break
    case 'FAILED_TEMPLATE':
      content = (
        <>
          <p>Production plan succeeded but the master agreement failed.</p>
          <p>This often happens when the file is larger than 5MB.</p>
        </>
      )
      bottomRow = (
        <Button
          styleType="success"
          customClassName="mr10"
          onClick={() => handleClose('SUCCESS')}
        >
          Continue
        </Button>
      )
      cancelFunction = () => handleClose('SUCCESS')
      break
    default:
      break
  }

  return (
    <Modal show={showModal} handleClose={cancelFunction}>
      <div
        data-testid="modal"
        className="w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4"
      >
        <div className="df jcsb">
          <p className="fz16 ml16 fw600">Production plan status</p>
          {submissionStatus !== 'LOADING' && (
            <button className="bdnone m0 bgc-t" onClick={cancelFunction}>
              <img src={clear} alt="cancel button" />
            </button>
          )}
        </div>
        <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
        {content}
        <hr className="mt20 mb16 bdnone bt1-s-lightgray" />
        <div className="df jcfe">{bottomRow}</div>
      </div>
    </Modal>
  )
}
export default ProductionPlanModal
